import { analytics } from "@lib/trackers/analytics";

export function productClickedEvent(dataToSend, trackingName) {
  if (dataToSend.algolia === undefined) return;

  analytics.track("Product Clicked", {
    tracking_name: trackingName,
    index: dataToSend.algolia.index_name,
    eventType: "click",
    queryID: dataToSend.algolia.query_id,
    objectID: dataToSend.objectID,
    position: dataToSend.position,
    filters: dataToSend.algolia.filters,
  });
}

export function productAddedEvent(dataToSend, trackingName) {
  if (!dataToSend.index || !dataToSend.queryID) return;

  analytics.track("Product Added", {
    tracking_name: trackingName,
    index: dataToSend.index,
    eventType: "conversion",
    queryID: dataToSend.queryID,
    objectID: dataToSend.objectID,
  });
}
